import React, { useState, useEffect } from "react";
import NewsCard from "../../Components/NewsCard";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { AiOutlineCaretRight } from "react-icons/ai";
import { motion } from "framer-motion";
import { client } from "../../client";

const News = ({ setSingleBlog }) => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    client.fetch(`*[_type == "blogs"]`).then((res) => setNews(res));
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 10000,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <motion.div
      id="news"
      whileInView={{ y: [50, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div className="mainContent">
        <div className="leftCol">
          <h1>News all over the world</h1>
          <p>We always give our best to satisfy your needs</p>

          <Link to="/" className="moreTools">
            View More <AiOutlineCaretRight className="ico" />
          </Link>
        </div>
        <div className="rightCol">
          <Slider {...settings} className="slider">
            {news.map((n, i) => {
              return (
                <div key={i}>
                  <NewsCard blog={n} setSingleBlog={setSingleBlog} />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </motion.div>
  );
};

export default News;
